import generateDate from "./generateDate.js";
const parserDates = (dates) => {
  const newDates = [];
  dates.forEach((date) => {
    if (date.match(/^(\d{4}-\d{2}-\d{2})$/g)) {
      newDates.push(date);
    } else {
      date.replace(/(\d{4}-\d{2}-\d{2}).*?(\d{4}-\d{2}-\d{2})/g, (_, d1, d2) => {
        const startDate = /* @__PURE__ */ new Date(`${d1}T00:00:00`);
        const endDate = /* @__PURE__ */ new Date(`${d2}T00:00:00`);
        const currentDate = new Date(startDate.getTime());
        for (currentDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
          newDates.push(generateDate(currentDate));
        }
        return _;
      });
    }
  });
  return newDates;
};
export {
  parserDates as default
};
